import { render, staticRenderFns } from "./ClientOrdersModal.vue?vue&type=template&id=eab905cc&scoped=true"
import script from "./ClientOrdersModal.vue?vue&type=script&lang=js"
export * from "./ClientOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./ClientOrdersModal.vue?vue&type=style&index=0&id=eab905cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab905cc",
  null
  
)

export default component.exports